let is_debug = false;

let config = {};

var config_dev = {
	// api请求地址
	baseUrl: 'http://work.miniprogram.api.jihua/',
	imgUrl:'http://work.miniprogram.api.jihua/'
};

var config_pro = {
  // api请求地址
  baseUrl: 'https://wechat-api.jihua-fs.com',
  imgUrl:'https://wechat-api.jihua-fs.com'
};

config = is_debug ? config_dev : config_pro;

export default config;



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 